<card>
    <div card-header>
        <h3 id="facility-heading" i18n>Facility</h3>
    </div>
    <div class="container-fluid page-container facility-card-component" card-body>
        <ng-container *ngIf="(activeDataSource$ | async | notNull).loading$ | async; else main">
            <lsq-circle-loader></lsq-circle-loader>
        </ng-container>

        <ng-template #main>
            <div>
                <tabs
                    [tabsConfig]="tabsConfig"
                    [shouldUseRouting]="false"
                    (tabClick)="activeTab$.next($event)"
                ></tabs>
            </div>
            <div *ngIf="(activeDataSource$ | async) === earlyPaymentDataSource">
                <lsq-hover-over-progress-bar
                    [value]="progressValueEp"
                    [dataSource]="earlyPaymentDataSource"
                    [dangerAboveThreshold]="100"
                    [onlyEarlyPaid]="onlyEarlyPaid"
                    [selectedAmountObservable]="selectedAmountObservable"
                ></lsq-hover-over-progress-bar>
            </div>
            <div
                *ngIf="
                    (isPayLaterEnabledForBuyer$ | async) &&
                    (activeDataSource$ | async) === flexTermDataSource
                "
            >
                <lsq-hover-over-progress-bar
                    [value]="progressValueFt"
                    [dataSource]="flexTermDataSource"
                    [dangerAboveThreshold]="100"
                    [onlyEarlyPaid]="onlyEarlyPaid"
                    [selectedAmountObservable]="selectedAmountObservable"
                ></lsq-hover-over-progress-bar>
            </div>
        </ng-template>
    </div>
</card>
